<template>
  <main-layout>
    <div>
      <!-- <status-dialog
        v-model="isStatusDialogOpened"
        :status="selectedStatus"
        @save="stateSave"
        @close="resetSelectedStatus"/>
      <delete-status-dialog
        v-model="isDeleteStatusDialogOpened"
        :status="selectedStatus"
        @delete="stateDelete"
        @close="resetSelectedStatus"/> -->
      <v-row no-gutters align="center" class="content-header">
        <span class="font-weight-bold">Logs</span>
        <v-spacer></v-spacer>
      </v-row>
      <div class="page-main-content">
        <n-card class="px-4 pt-4 pb-12">
          <div class="text-left">Comming soon...</div>
        </n-card>
        <!-- <v-simple-table class="pt-5">
          <thead>
            <tr>
              <th class="text-left">Nom</th>
              <th class="text-left">Couleur</th>
              <th class="text-left">Intervention cloturée ?</th>
              <th/>
            </tr>
          </thead>
          <tbody>
            <tr v-for="(status, i) in statuses" :key="status.name">
              <td>{{ status.name }}</td>
              <td>
                <v-sheet
                  width="125"
                  height="15"
                  :color="status.color"
                  class="sheet-item"
                ></v-sheet>
              </td>
              <td>{{ status.isFinished ? `Oui` : `Non` }}</td>
              <td class="text-right admin-list-actions">
                <v-btn :disabled="!$canWrite" icon small @click="$canWrite && (saveStatus(status))"><v-icon>edit</v-icon></v-btn>
                <v-btn
                  icon
                  small
                  v-if="i !== 0 && i !== statuses.length - 1"
                >
                  <v-icon :disabled="!$canWrite" color="red" @click="$canWrite && (deleteStatus(status))">delete</v-icon>
                </v-btn>
              </td>
            </tr>
          </tbody>
        </v-simple-table> -->
      </div>
    </div>
  </main-layout>
</template>

<script>
// import { mapState } from 'vuex';
import MainLayout from '@/views/indeegoSettings/MainLayout.vue';
// import StatusDialog from '@/components/Status/StatusDialog.vue';
// import DeleteStatusDialog from '@/components/Status/DeleteStatusDialog.vue';

export default {
  data: () => ({
    // isNewClientDialogOpened: false,
    // isDeleteStatusDialogOpened: false,
    // selectedStatus: {},
  }),
  // computed: {
  //   ...mapState(`model/status`, [
  //     `statuses`,
  //   ]),
  // },
  // methods: {
  //   saveStatus(status) {
  //     this.selectedStatus = status;
  //     this.isStatusDialogOpened = true;
  //   },
  //   deleteStatus(status) {
  //     this.selectedStatus = status;
  //     this.isDeleteStatusDialogOpened = true;
  //   },
  //   fetchStatuses() {
  //     this.$store.dispatch(`model/status/fetchStatuses`);
  //   },
  //   async stateSave() {
  //     await this.$store.dispatch(`showSnackbar`, {
  //       color: `success`,
  //       message: this.selectedStatus && this.selectedStatus.id ? `Statut modifié avec succès` : `Statut créé avec succès`,
  //     });
  //     this.selectedStatus = {};
  //   },
  //   async stateDelete() {
  //     await this.$store.dispatch(`showSnackbar`, {
  //       color: `success`,
  //       message: `Statut supprimé avec succès`,
  //     });
  //     this.selectedStatus = {};
  //   },
  //   resetSelectedStatus() {
  //     this.selectedStatus = {};
  //   },
  // },
  // mounted() {
  //   this.fetchStatuses();
  // },
  components: {
    MainLayout,
    // StatusDialog,
    // DeleteStatusDialog,
  },
};
</script>

<style lang="scss">
</style>
